import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export const useAccount = (accountID, shareID) => {
    const queryClient = useQueryClient();
    return useQuery({
        queryKey: [accountID, "account"],
        queryFn: () =>
            axios
                .get(`/api/${accountID}`, {
                    headers: {
                        ["X-Share-Id"]: shareID
                    }
                })
                .then(({ data }) => data),
        initialData: () => {
            return queryClient
                .getQueryData(["me", "accounts"])
                ?.find(a => a.accountID === accountID);
        }
    });
};

export const useUsers = accountID => {
    return useQuery({
        queryKey: [accountID, "users"],
        queryFn: () => axios.get(`/api/${accountID}/users`).then(({ data }) => data)
    });
};

export const useAssignUser = accountID => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: user => axios.post(`/api/${accountID}/users`, user).then(({ data }) => data),
        onSettled: () => {
            queryClient.refetchQueries([accountID, "users"]);
        }
    });
};

export const useUnassignUser = accountID => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: userID =>
            axios.delete(`/api/${accountID}/users/${userID}`).then(({ data }) => data),
        onSettled: () => {
            queryClient.refetchQueries([accountID, "users"]);
        }
    });
};

export const useShowSettings = accountID => {
    return useQuery({
        queryKey: [accountID, "show-settings"],
        queryFn: () => axios.get(`/api/${accountID}/show-settings`).then(({ data }) => data)
    });
};

export const usePrefetchShowSettings = accountID => {
    const queryClient = useQueryClient();
    return queryClient.prefetchQuery({
        queryKey: [accountID, "show-settings"],
        queryFn: () => axios.get(`/api/${accountID}/show-settings`).then(({ data }) => data)
    });
};
